import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {formatNumberSum} from '@specials/utils';

import {STATISTIC_ITEM_HUGE_VALUE_SIGNS_AFTER_COMMA} from '@/constants';
import {SecondsValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateSeconds = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (!ValidationUtils.isValidationRule<SecondsValidationRule>(rule, StatisticItemValidationType.Seconds)) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;
  const numberStatisticValue = Number(statisticValue);

  if (ValidationUtils.isInvalidNumberValue(statisticValue)) {
    // логируем не числовое значение
    const error = FrontendError.createParseNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue) {
    const parsedSecondsValue = Math.floor(numberStatisticValue / ruleValue);
    statisticValue = parsedSecondsValue.toString();
  }

  // округление для млн, млрд значений
  statisticValue = formatNumberSum(Number(statisticValue), {
    round: STATISTIC_ITEM_HUGE_VALUE_SIGNS_AFTER_COMMA,
  });

  return statisticValue;
};
